import React from 'react';

import { useIntl } from 'react-intl-next';

import { LinkButton } from '@atlaskit/button/new';
import Image from '@atlaskit/image';
import Link from '@atlaskit/link';

import { ErrorLayout } from '../error-layout';

import UnknownError from './assets/UnknownError.svg';
import messages from './messages';

export const UnknownErrorPage = () => {
	const { formatMessage } = useIntl();

	return (
		<ErrorLayout
			illustration={<Image src={UnknownError} alt={formatMessage(messages.imageAlt)} />}
			heading={formatMessage(messages.heading)}
			message={formatMessage(messages.message, {
				Link: (chunks: React.ReactNode[]) => (
					<Link href="https://status.atlassian.com/">{chunks}</Link>
				),
			})}
			action={
				<LinkButton href="https://status.atlassian.com/">
					{formatMessage(messages.action)}
				</LinkButton>
			}
		/>
	);
};
